import { useEffect } from "react";
import classes from "./Timer.module.css";

const Timer = ({ setCountDown, countDown, clearTimer, getDeadTime }) => {
  // useEffect(() => {
  //   let myInterval = setInterval(() => {
  //     console.log("first");
  //     if (countDown > 0) {
  //       setCountDown((ps) => ps - 1);
  //     }
  //     if (countDown === 0) {
  //       clearInterval(myInterval);
  //     }
  //   }, 500);
  //   return () => {
  //     clearInterval(myInterval);
  //   };
  // });

  useEffect(() => {
    clearTimer(getDeadTime());
  }, []);

  return (
    <span
      className={[classes.timerTxt, countDown === "00:00" ? classes.hideTimer : classes.showTimer].join(
        " "
      )}
    >
      {countDown}
    </span>
  );
};

export default Timer;
